module.exports = __webpack_public_path__ + "static/uni_uncf_2-c41e87722e683d5599457f7b67d16b17.png";